exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message-action{z-index:1000}.message-action .md-dialog-container{height:auto;width:auto}.radio-container{display:flex;flex-direction:column;margin:10px}.rating-container{display:flex;flex-direction:row}.extra-container{margin:5px;padding:5px}.extra-container,.reason-container{display:flex;flex-direction:column}.open-reason-comment{width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/ticketMessageAction.vue
// module id = 417
// module chunks = 0